import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Check } from 'lucide-react';
export function Guarantee() {
  const bullets = ['7 días completos', 'Sin preguntas', 'Reembolso 100%'];
  return <section className="py-16 md:py-24 px-4 bg-black" data-id="element-76">
      <div className="max-w-3xl mx-auto" data-id="element-77">
        <FadeIn className="glow-beige bg-black rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-78">
          <div className="absolute top-0 left-0 w-full h-2 bg-sand/60" data-id="element-79" />

          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-sand/10 border border-sand/30 mb-6" data-id="element-80">
            <ShieldCheck size={32} className="text-sand" data-id="element-81" />
          </div>

          <span className="text-cream/50 text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-82">
            Compra 100% Protegida
          </span>

          <h2 className="font-display text-3xl md:text-4xl font-bold text-cream mb-6" data-id="element-83">
            Garantía de 7 días
          </h2>

          <p className="text-lg text-cream/70 max-w-2xl mx-auto leading-relaxed mb-8" data-id="element-84">
            Probalo por 7 días completos. Si sentís que no te da más claridad,
            más orden y mejores herramientas para consulta infantil, te
            devolvemos tu dinero. Sin vueltas.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-8" data-id="element-85">
            {bullets.map((bullet, idx) => <div key={idx} className="flex items-center gap-2 text-cream/80 font-bold" data-id="element-86">
                <Check size={18} className="text-sand" data-id="element-87" />
                <span data-id="element-88">{bullet}</span>
              </div>)}
          </div>

          <div className="inline-block border-t border-sand/30 pt-6" data-id="element-89">
            <p className="text-sand font-medium italic" data-id="element-90">
              Riesgo cero — la garantía corre por nuestra cuenta.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}